module.exports = __webpack_public_path__ + "static/media/0501.bca23444.png";